export default "__VITE_ASSET__HUuEd73A__"